import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import { Box, BoxId } from 'models/Box';
import { notify, NotificationType } from 'xstate/actors/NotificationActor';
import { updateBoxAppearance } from '../services/box.service';

type Variables = {
  boxId: BoxId;
  color: string | null;
  emoji: string | null;
};

export const useUpdateBoxAppearance = ({
  onSuccess,
}: {
  onSuccess?: (box: Box) => void;
} = {}) => {
  const queryClient = useQueryClient();

  return useMutation<Box, unknown, Variables>({
    mutationFn: ({ boxId, color, emoji }) =>
      updateBoxAppearance(boxId, { color, emoji }),
    onSuccess: (updatedBox) => {
      // Refresh every space's box list so the new tile appearance shows up.
      queryClient.invalidateQueries({ queryKey: [QueryKey.BOXES] });
      notify(NotificationType.BOX_UPDATED);
      onSuccess?.(updatedBox);
    },
  });
};
